import { changePasswordHeaderStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordHeader";
import { css } from "styled-components";

Object.assign(changePasswordHeaderStyles, {
    headerGridContainer: {
        gap: 0,
        css: css`
            width: calc(100% + 20px) !important;
        `,
    },
    buttonGridItem: {
        css: css`
            justify-content: flex-end;
        `,
        width: [12, 12, 4, 4, 3],
    },
    titleGridItem: {
        width: [12, 12, 8, 8, 9],
    },
    title: {
        variant: "h2",
        as: "h1",
        css: css`
            display: none;
        `,
    },
    actions: {
        css: css`
            width: 100%;
        `,
    },
});
